function PropertyMapSection({ mapEmbedUrl, mapLinkUrl, property }) {
  return (
    <section className="mt-6 grid gap-6 lg:grid-cols-[minmax(0,1fr)_320px]">
      <div className="overflow-hidden rounded-[32px] border border-[#1832281a] bg-[rgba(249,245,238,0.88)] shadow-[0_22px_60px_rgba(24,50,40,0.08)]">
        <div className="flex items-center justify-between gap-4 border-b border-[#18322812] px-6 py-5 md:px-8">
          <div>
            <p className="mb-2 text-xs uppercase tracking-[0.16em] text-[#7c6b52]">Kart</p>
            <h2 className="font-serif text-[clamp(1.8rem,3vw,2.5rem)] font-semibold leading-[1.08] text-[#163127]">
              Se eiendommen i Google Maps
            </h2>
          </div>
          <a
            className="inline-flex min-h-11 items-center justify-center rounded-full border border-[rgba(29,76,59,0.18)] bg-[rgba(255,255,255,0.7)] px-5 font-semibold text-[#1d4c3b] no-underline"
            href={mapLinkUrl}
            rel="noreferrer"
            target="_blank"
          >
            Aapne i Google Maps
          </a>
        </div>
        <iframe
          className="min-h-[380px] w-full border-0"
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          src={mapEmbedUrl}
          title={`Kart for ${property.name}`}
        />
      </div>

      <aside className="rounded-[32px] border border-[#1832281a] bg-[rgba(249,245,238,0.88)] p-6 shadow-[0_22px_60px_rgba(24,50,40,0.08)] md:p-8">
        <p className="mb-3 text-xs uppercase tracking-[0.16em] text-[#7c6b52]">Adresse</p>
        <p className="mb-2 font-semibold text-[#163127]">{property.name}</p>
        <p className="text-[1.05rem] leading-[1.8] text-[#355046]">{property.address}</p>
        <p className="mt-4 text-[1rem] leading-[1.7] text-[#355046]">
          Kartet viser området rundt eiendommen, slik at du enkelt kan se beliggenhet og avstand til områdene som er
          viktige for deg. Åpne kartet i Google Maps for veibeskrivelse.
        </p>
      </aside>
    </section>
  );
}

export default PropertyMapSection;